export default __webpack_public_path__ + "static/media/logo.b4da8071.svg";